import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Button, Input, Loading } from 'element-react'
import FleetFilters from '../../components/user/includes/FleetFilters'
import FormMessage from '../../components/user/includes/FormMessage'
import { tagHotjarRecording, encodeEquipmentId } from '../../helpers/util'
import Spacer from '../../components/views/includes/Spacer'
import {
    MainSection,
    AppContainer,
    Section,
    TitleBar,
} from '../../components/views/includes/Wrappers'
import useFleet from '../../hooks/useFleet'
import useAuth from '../../hooks/useAuth'
import AppRoutes from '../../routes/appRoutes'
import { useFetchState } from '../../context/FetchStateContext'

const SelectAssetPage = props => {
    const { location } = props

    let timeout = 0

    const { user } = useAuth()
    const locationDefaults = Array.from(user?.locationPreferences)
    const [showFiltersDialog, setShowFiltersDialog] = useState(false)
    const [showMessage, setShowMessage] = useState(false)
    const [fleetList, setFleetList] = useState([])
    const [filteredLocations, setFilteredLocations] = useState([])
    const [fleetFilters, setFleetFilters] = useState()
    const [query, setQuery] = useState('')
    const [isLoading, setIsLoading] = useState(true)
    const [filterCount, setFilterCount] = useState(0)
    const [showFleetList, setShowFleetList] = useState({})
    const [resultCount, setResultCount] = useState(0)
    const [toggleSearch, setToggleSearch] = useState(false)
    const { handleSearchFleet } = useFleet()
    const { setIsFetching, setDataFetched } = useFetchState()

    useEffect(() => {
        let locPrefs = user?.locationPreferences
        var filteredLocs = user?.company?.shiptos?.filter(el => {
            return locPrefs?.indexOf('' + el.id) !== -1
        })
        setFilteredLocations(filteredLocs)

        return () => {
            clearTimeout(timeout)
        }
    }, [])

    useEffect(() => {
        filter()
    }, [toggleSearch])

    const handleToggleSearch = () => {
        setToggleSearch(!toggleSearch)
    }

    const closeFiltersDialog = () => {
        setShowFiltersDialog(false)
    }

    const updateFilterCount = count => {
        setFilterCount(count)
    }

    const handleFilters = filters => {
        setFleetFilters(filters)
        setIsLoading(true)
        setShowMessage(false)
        setFleetList([])
        handleToggleSearch()
    }

    const handleSearch = value => {
        setIsLoading(true)
        setShowMessage(false)
        setFleetList([])
        timeout = setTimeout(() => {
            setQuery(value)
            handleToggleSearch()
        }, 400)
    }

    const onFilterSuccess = response => {
        const updatedShowList = Object.keys(response?.data?.fleet || {}).reduce(
            (acc, key) => {
                acc[key] = acc[key] || true
                return acc
            },
            {},
        )

        setFleetList(response.data.fleet)
        setResultCount(response.data.resultCount)
        setIsLoading(false)
        setShowMessage(false)
        setShowFleetList(updatedShowList)
        setIsFetching(false)
        setDataFetched(true)
    }

    const onFilterError = error => {
        tagHotjarRecording('API Error')
        setShowMessage(true)
        setIsLoading(false)
        setFleetList([])
        setResultCount(error.response.data.resultCount)
        setIsFetching(false)
        setDataFetched(true)
    }

    const filter = () => {
        setIsFetching(true)
        const searchInfo = {
            query: query,
            categories: fleetFilters,
            user: user?.id,
        }
        handleSearchFleet(searchInfo, onFilterSuccess, onFilterError)
    }

    const toggleShowFleetList = key => {
        let showList = {
            ...showFleetList,
            [key]: !showFleetList[key],
        }
        setShowFleetList(showList)
    }

    return (
        <div>
            <AppContainer className="sticky-button">
                <header className="header--main">
                    <Section>
                        <TitleBar
                            title="Select Asset for Repair"
                            backLink={
                                location.state && location.state.source
                                    ? location.state.source
                                    : '/requests'
                            }
                        >
                            <a onClick={() => setShowFiltersDialog(true)}>
                                <i
                                    className={
                                        filterCount <= 0
                                            ? 'icon-filter-outline'
                                            : 'icon-filter'
                                    }
                                    data-count={filterCount}
                                ></i>
                            </a>
                        </TitleBar>
                    </Section>
                    <div className="row">
                        <div className="columns small-12">
                            {/* Search Asset Bar */}
                            <form method="GET" onSubmit={handleSearch}>
                                <Input
                                    className="search"
                                    placeholder="Find Asset"
                                    name="query"
                                    onChange={handleSearch}
                                />
                            </form>
                        </div>
                    </div>
                </header>

                <Spacer size="tiny" />

                <MainSection className="fleet-list selection">
                    {isLoading && (
                        <div className="demo-loading padding-top-large padding-bottom-large">
                            {' '}
                            <Loading text="Loading Results"> </Loading>
                        </div>
                    )}

                    {showMessage && (
                        <FormMessage
                            messageTitle="No equipment found"
                            messageContent="Please check your filter and location preferences."
                            buttonLink={AppRoutes.profile()}
                            buttonLabel="Manage Preferences"
                        ></FormMessage>
                    )}

                    {Object.keys(fleetList).map(key => (
                        <div key={'row_' + key} className="location">
                            <div
                                className="location--name"
                                onClick={() => toggleShowFleetList(key)}
                            >
                                <div className="row">
                                    <div className="columns small-12">
                                        <h3
                                            className={
                                                showFleetList[key]
                                                    ? 'open'
                                                    : 'close'
                                            }
                                        >
                                            {fleetList[key].name}
                                        </h3>
                                        <small>{fleetList[key].address}</small>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="columns small-12">
                                    <div
                                        className={
                                            showFleetList[key]
                                                ? 'toggle-display--list'
                                                : 'toggle-hidden--list'
                                        }
                                    >
                                        <ul className="location--list">
                                            {Array.isArray(
                                                fleetList[key].assets,
                                            ) &&
                                                fleetList[key].assets.map(
                                                    row => (
                                                        <li
                                                            key={
                                                                'item_row_' +
                                                                row.id
                                                            }
                                                        >
                                                            {/* Image OR Icon */}
                                                            {/* ++++++++++++++++++++++++++++++++++++++++++
                                            Uses icon if no image exists.
                                        ++++++++++++++++++++++++++++++++++++++++++++*/}
                                                            {/* <img className="item-img" src="https://via.placeholder.com/35" /> */}
                                                            <Link
                                                                to={{
                                                                    pathname: AppRoutes.createRequests(
                                                                        encodeEquipmentId(
                                                                            row.serial_lot_number,
                                                                        ),
                                                                    ),
                                                                    state: {
                                                                        source:
                                                                            location.state &&
                                                                            location
                                                                                .state
                                                                                .source
                                                                                ? location
                                                                                      .state
                                                                                      .source
                                                                                : AppRoutes.selectAsset(),
                                                                    },
                                                                }}
                                                                backlink={AppRoutes.selectAsset()}
                                                            >
                                                                <i className="item-icon icon-forklift"></i>
                                                            </Link>

                                                            {/* Content */}
                                                            {/* ++++++++++++++++++++++++++++++++++++++++++
                                            If no name use the serial as the name.
                                        ++++++++++++++++++++++++++++++++++++++++++++*/}
                                                            <Link
                                                                to={{
                                                                    pathname: AppRoutes.createRequests(
                                                                        encodeEquipmentId(
                                                                            row.serial_lot_number,
                                                                        ),
                                                                    ),
                                                                    state: {
                                                                        source:
                                                                            location.state &&
                                                                            location
                                                                                .state
                                                                                .source
                                                                                ? location
                                                                                      .state
                                                                                      .source
                                                                                : AppRoutes.selectAsset(),
                                                                    },
                                                                }}
                                                                backlink={AppRoutes.selectAsset()}
                                                                className="content"
                                                            >
                                                                <h6>
                                                                    {row.customer_alias
                                                                        ? row.customer_alias
                                                                        : row.name}
                                                                </h6>
                                                                <span className="serial">
                                                                    {
                                                                        row.equipment_number
                                                                    }
                                                                </span>
                                                                <span className="category">
                                                                    {row.manufacturer !=
                                                                    'Other'
                                                                        ? row.manufacturer
                                                                        : ''}{' '}
                                                                    {row.type}
                                                                </span>

                                                                {/* Link */}
                                                                <span className="arrow-link">
                                                                    <i className="icon-chevron-thin-right"></i>
                                                                </span>
                                                            </Link>
                                                        </li>
                                                    ),
                                                )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </MainSection>
            </AppContainer>

            {/* Using a flag to show FleetFilters is a bug fix for IE */}
            {showFiltersDialog && (
                <FleetFilters
                    onChange={handleFilters}
                    onClose={closeFiltersDialog}
                    locationDefaults={locationDefaults}
                    locations={filteredLocations}
                    resultCount={resultCount}
                    storedFilters={fleetFilters}
                    updateFilterCount={updateFilterCount}
                />
            )}

            <Link
                to={{
                    pathname: AppRoutes.createAsset(),
                    state: {
                        source: AppRoutes.selectAsset(),
                    },
                }}
                className="button-fixed-bottom"
            >
                <Button type="primary" className="expanded">
                    Add New Asset
                </Button>
            </Link>
        </div>
    )
}

SelectAssetPage.propTypes = {
    location: PropTypes.shape({
        state: PropTypes.shape({
            source: PropTypes.string,
        }),
    }),
}

export default SelectAssetPage
